import activityLog from 'modules/activityLog/ActivityLog/slices/activityLog'
import aproLogDetails from 'modules/activityLog/details/AproLogDetails/slices/aproLogDetails'
import certificateLogDetails from 'modules/activityLog/details/CertificateLogDetails/slices/certificateLogDetails'
import cesTestLogDetails from 'modules/activityLog/details/CesTestLogDetails/slices/cesTestLogDetails'
import courseLogDetails from 'modules/activityLog/details/CourseLogDetails/slices/courseLogDetails'
import cstLogDetails from 'modules/activityLog/details/CstLogDetails/slices/cstLogDetails'
import educationLogDetails from 'modules/activityLog/details/EducationLogDetails/slices/educationLogDetails'
import elearningLogDetails from 'modules/activityLog/details/ElearningLogDetails/slices/elearningLogDetails'
import onboardAssessmentLogDetails from 'modules/activityLog/details/OnboardAssessmentLogDetails/slices/onboardAssessmentLogDetails'
import pproLogDetails from 'modules/activityLog/details/PproLogDetails/slices/pproLogDetails'
import rapidElearningLogDetails from 'modules/activityLog/details/RapidElearningLogDetails/slices/rapidElearningLogDetails'

const slices = {
  activityLog,
  aproLogDetails,
  certificateLogDetails,
  cesTestLogDetails,
  courseLogDetails,
  cstLogDetails,
  educationLogDetails,
  elearningLogDetails,
  onboardAssessmentLogDetails,
  pproLogDetails,
  rapidElearningLogDetails,
}

export default slices
